import { Modal } from "react-bootstrap";
import React, { ReactNode, useState } from "react";
import { FormattedMessage } from "react-intl";
import classes from "./GenericOTPModal.module.scss";
import messages from "./module/messages";
import { CssTextField } from "../../TextInputField/TextInputField";
import { IDataPostLogin } from "../../../pages/Login/module/constants";

interface GenericOTPModalProps {
  show: boolean;
  modalTitle?: string | ReactNode;
  label?: string | ReactNode;
  extraTxtContent?: string | ReactNode;
  receiver?: string;
  onClose: () => void;
  onConfirm: (otp: string) => void;
}

function GenericOTPModal({
  show,
  label,
  modalTitle,
  extraTxtContent,
  receiver,
  onClose,
  onConfirm,
}: GenericOTPModalProps) {
  const [otp, setOtp] = useState<string>("");
  return (
    <Modal
      show={show}
      size={"sm"}
      onHide={onClose}
      centered
      contentClassName={classes.content}
    >
      <Modal.Header className={classes.header}>
        <Modal.Title style={{ fontSize: "1rem" }}>
          {modalTitle && modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.75rem" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ margin: ".5rem" }}>
            {extraTxtContent} {receiver}
          </div>
          <div style={{ textTransform: "uppercase", margin: ".5rem 0" }}>
            {label}
          </div>
          <div>
            <CssTextField
              variant="filled"
              fullWidth
              type={"text"}
              onChange={(val: any) => setOtp(val.target.value)}
              value={otp}
              label={label}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className={classes.footer}>
        <div className={classes.btnWrapper}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={onClose}
          >
            <FormattedMessage {...messages.closeBtn} />
          </button>

          {/* {timeLeft > 0 && retrysLeft > 0 && ( */}
          <button
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={() => onConfirm(otp)}
            disabled={otp.length === 0}
          >
            <FormattedMessage {...messages.confirmBtn} />
          </button>
        </div>
        {/* )} */}
      </Modal.Footer>
    </Modal>
  );
}

export default GenericOTPModal;
